import React from 'react';
import SessionManagementView from './SessionManagementView';

const SessionManagementContainer = (props) => {
  return <SessionManagementView {...props} />;
};

export default SessionManagementContainer;
